import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { SampleView } from 'src/app/shared/enums/sample-view.enum';
import { Sample } from 'src/app/shared/models/sample.model';
import { CurrentOrderService } from 'src/app/shared/services/current-order.service';
import { TestParameter, Parameter } from 'src/app/shared/models/specification/test-parameter.model';
import { BaseComponent } from 'src/app/features/guided-order/base.component';
import { SpecificationHelper } from 'src/app/features/guided-order/samples/services/specification-helper.service';
import { ResultConversionCode } from '../models/specification/result-conversion-code.model';
import { HelperService } from '../services/helper.service';
import { ParameterType } from '../models/specification/parameter-type.model';

@Component({
  selector: 'app-specification-detail',
  templateUrl: './specification-detail.component.html',
  styleUrls: ['./specification-detail.component.scss']
})
export class SpecificationDetailComponent extends BaseComponent implements OnInit, OnChanges {

  @Input() sampleView: SampleView;
  @Input() sample: Sample;
  @Input() specificationDetail: any;

  @Output() public openSidebar = new EventEmitter<{ sidebar: string }>();

  sampleDisplay = SampleView;
  currentSample: Sample;
  columnHeaders: any[];
  dateFormat: any;
  isLabelClaimSpecSelected = false;
  isVisibility: boolean = true;

  @Input() specificationsAdded: boolean;
  @Input() isReadOnly: boolean;

  constructor(
    currentOrderService: CurrentOrderService,
    private specificationHelperService: SpecificationHelper,
    private helperService: HelperService) {
    super(currentOrderService);
    this.specificationHelperService.specificationUpdater.subscribe(() => {
      if (this.currentSample.specificationResponses && this.currentSample.specificationResponses.length > 0) {
        this.columnHeaders = this.specificationHelperService.loadSpecificationGridHeaders(this.currentSample);
        this.isVisibility = this.specificationHelperService.returnSpecificationVisibility(this.currentSample);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sample) {
      this.getSelectedSampleFromCurrentOrder();
      if (this.currentSample.specificationResponses && this.currentSample.specificationResponses.length > 0) {
        this.columnHeaders = this.specificationHelperService.loadSpecificationGridHeaders(this.currentSample);
        this.isVisibility = this.specificationHelperService.returnSpecificationVisibility(this.currentSample);
      }
    }
    if (changes.specificationDetail) {
      this.getSelectedSampleFromCurrentOrder();
      if (this.currentSample.specificationResponses && this.currentSample.specificationResponses.length > 0) {
        this.columnHeaders = this.specificationHelperService.loadSpecificationGridHeaders(this.currentSample);
        this.currentSample.isSpecificationsEdited = false;
        this.isVisibility = this.specificationHelperService.returnSpecificationVisibility(this.currentSample);
      }
    }
  }

  ngOnInit(): void {
    this.dateFormat = this.helperService.getDateOriginalFormat(window.navigator.language);
    this.getSelectedSampleFromCurrentOrder();
    if (this.currentSample.specificationResponses && this.currentSample.specificationResponses.length > 0) {
      this.columnHeaders = this.specificationHelperService.loadSpecificationGridHeaders(this.currentSample);
      this.isVisibility = this.specificationHelperService.returnSpecificationVisibility(this.currentSample);
    }
  }

  get ParameterType() {
    return ParameterType;
  }

  getSelectedSampleFromCurrentOrder() {
    this.currentSample =
      this.currentOrder.samples.filter(x => x.sampleCode === this.sample.sampleCode).shift();
  }

  showAddSpecificationsPanel() {
    if (!this.disableSpecification()) {
      this.openSidebar.emit({ sidebar: 'specifications' });
    }
  }

  disableSpecification(): boolean {
    const sample = this.currentOrder.samples.filter(x => x.sampleCode === this.currentSample.sampleCode).shift();
    if (this.currentSample.resultConversion === ResultConversionCode.DV &&
      (!Number(sample.servingSize) || !sample.servingUnitNumeratorCode)) {
      return true;
    }

    if (new RegExp(`^(${ResultConversionCode.NONE}|${ResultConversionCode.LC})$`).test(this.currentSample.resultConversion)
      && Number(sample.servingSize)
      && !sample.servingUnitNumeratorCode) {
      return true;
    }

    if (this.currentSample.testParameters) {
      return this.currentSample.testParameters.length === 0;
    }
    return true;
  }

  testParameterMandatoryFields(testParameters: TestParameter[]): Parameter[] {
    const mandatoryParameters: Parameter[] = [];
    testParameters.forEach(t => {
      mandatoryParameters.push(...t.parameters.filter(x => x.requiresExpectedValue));
    });
    return mandatoryParameters;
  }

  isMandatoryParameterExists(): boolean {
    const mandatoryParameters = this.testParameterMandatoryFields(this.currentSample.testParameters);
    return mandatoryParameters.length > 0;
  }

  showLabelClaimSpecHint(): boolean {
    const resultConversion = this.currentSample.resultConversion;

    if (this.currentSample?.specifications.length > 0) {
      let targetValuesPresent = false;
      this.currentSample?.specifications?.forEach(s => {
        s.parameters?.forEach(p => {
          if (p?.labelClaimSpecification?.target?.trim() === undefined) {
            targetValuesPresent = false;
          } else if (p?.labelClaimSpecification?.target?.trim() !== '') {
            targetValuesPresent = true;
          }
        });
      });

      if (targetValuesPresent) {
        return false;
      }
    }

    if (resultConversion === ResultConversionCode.LC) {
      return true;
    } else {
      this.currentOrderService.currentOrder.isLabelClaimMSpecMissing = false;
      return false;
    }
  }

  showLabelClaimAsterick() {
    return this.currentSample.resultConversion === ResultConversionCode.LC;
  }

  showLabelClaimSpecHintInRed(): boolean {
    return this.currentOrderService.currentOrder.isLabelClaimMSpecMissing;
  }
}
